import { hashKey, useQuery } from '@tanstack/react-query';
import _ from 'lodash';

import { GoodLocationListItem } from '@e-origin/contracts';
import { GoodLocationCriteria, GoodsLocationQualifierIdentification, SortDirection } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const defaultGoodLocationCriteria: GoodLocationCriteria = {
  filters: { searchQuery: '' },
  pagination: { page: 1, size: 10 },
  sorting: { field: 'updatedAt', direction: SortDirection.DESC },
};

export const useGoodLocation = (declarantId?: string, criteria?: GoodLocationCriteria) =>
  useQuery({
    queryKey: ['good-locations', declarantId, ...(criteria ? [hashKey([criteria])] : [])],
    queryFn: async (): Promise<{ data: GoodLocationListItem[]; totalItems: number }> => {
      try {
        const result = await apiClient.declarant.retrieveGoodLocations.mutation({ body: { criteria }, params: { declarantId } });
        if (result.status !== 200) throw result.body;

        const locations = (result.body.data?.goodLocations || []).map((location: any) => {
          let city = 'N/A';
          if (location.address?.city) {
            city = location.address.city;
          }
          let postcode = 'N/A';
          if (location.qualifierOfIdentification === GoodsLocationQualifierIdentification.POSTCODE_ADDRESS && location.postcode?.postcode) {
            postcode = location.postcode.postcode;
          } else if (location.qualifierOfIdentification === GoodsLocationQualifierIdentification.ADDRESS && location.address?.postcode) {
            postcode = location.address.postcode;
          }
          return { ...location, virtuals: { displayedCity: city, displayedPostcode: postcode } };
        });

        return {
          data: locations,
          totalItems: result.body.data?.totalItems || 0,
        };
      } catch (error) {
        showErrorToast(error, 'Error fetching the goods locations!');
        return {
          data: [],
          totalItems: 0,
        };
      }
    },
    enabled: !!declarantId,
    placeholderData: { data: [], totalItems: 0 },
  });
